import { render, staticRenderFns } from "./EditProductForm.vue?vue&type=template&id=07a728c2&scoped=true"
import script from "./EditProductForm.vue?vue&type=script&lang=js"
export * from "./EditProductForm.vue?vue&type=script&lang=js"
import style0 from "./EditProductForm.vue?vue&type=style&index=0&id=07a728c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a728c2",
  null
  
)

export default component.exports